import {
  ExtendedFacetNode,
  FacetKey,
  FacetNodeType,
  Facets,
  Search,
  SearchRequest, SimpleFacetNode
} from '../domain/search.model';
import {
  ExtendedFacetNodeDto,
  FacetsDto,
  SearchRequestDto,
  SearchRequestFiltersDto,
  SearchResponseDto,
  SimpleFacetNodeDto
} from './search.dto';
import {mapScheme} from '../../scheme/data/scheme.mapper';

const mapExtendedFacetNode = (dto: ExtendedFacetNodeDto): ExtendedFacetNode => {
  return {
    type: FacetNodeType.EXTENDED,
    id: dto.id,
    label: dto.label,
    count: dto.count,
    level: dto.level,
    filterField: dto.filterField,
    filterValue: dto.filterValue,
    children: dto.children?.map(mapExtendedFacetNode)
  };
}

const mapSimpleFacetNode = (dto: SimpleFacetNodeDto): SimpleFacetNode => {
  return {
    type: FacetNodeType.SIMPLE,
    value: dto.value,
    count: dto.count
  };
}

const mapFacets = (dto: FacetsDto): Facets => {
  return {
    [FacetKey.PRODUCTS]: dto.products?.map(mapExtendedFacetNode) ?? [],
    [FacetKey.PRODUCTS_CASCADE]: dto.productsCascade?.map(mapExtendedFacetNode) ?? [],
    [FacetKey.CONTROL_PLATFORMS]: dto.controlPlatforms?.map(mapSimpleFacetNode) ?? [],
  };
}

const groupNodesByFilterField = (nodes: ExtendedFacetNode[]): Record<string, string[]> => {
  return nodes.reduce((acc, node) => {
    if (!acc[node.filterField]) {
      acc[node.filterField] = [];
    }
    acc[node.filterField].push(node.filterValue);
    return acc;
  }, {} as Record<string, string[]>);
}

const mapFacetsToDto = (facets: Facets): SearchRequestFiltersDto => {
  return {
    products: facets[FacetKey.PRODUCTS].length
      ? groupNodesByFilterField(facets[FacetKey.PRODUCTS])
      : undefined,
    productsCascade: facets[FacetKey.PRODUCTS_CASCADE].length
      ? groupNodesByFilterField(facets[FacetKey.PRODUCTS_CASCADE])
      : undefined,
    controlPlatforms: facets[FacetKey.CONTROL_PLATFORMS].length
      ? facets[FacetKey.CONTROL_PLATFORMS].map(n => n.value)
      : undefined,
  };
}

export const mapSearchRequest = (request: SearchRequest): SearchRequestDto => {
  return {
    country: request.country,
    language: request.language,
    filters: request.filters ? mapFacetsToDto(request.filters) : null,
    query: request.query ?? null,
    cursor: request.cursor,
  };
}

export const mapSearch = (dto: SearchResponseDto): Search => {
  return {
    items: dto.items.map(mapScheme),
    total: dto.total,
    facets: dto.facets ? mapFacets(dto.facets) : null,
    page: {
      hasMore: dto.page.hasMore,
      nextCursor: dto.page.nextCursor,
    },
  };
}
